module.exports = __webpack_public_path__ + "static/img/wechat.0b1aec4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/foot/wechat.png
// module id = yZoJ
// module chunks = 7